<template>
  <div class="mx-4 mb-4">
    <div style="position:relative;">
      <v-layout wrap
        ><v-flex xs12>
          <span class="hidden-sm-and-up"
            ><v-btn
              icon
              color="primary"
              to="/weserve_admin_login/-/reportdashboard/main"
              class="pa-4"
            >
              <v-icon color="black">arrow_back</v-icon></v-btn
            ></span
          >
          <div class="mb-3 mt-4" style="position: relative">
            <div style="display: flex; align-items: center">
              <span class="hidden-sm-and-down"
                ><v-btn
                  icon
                  color="primary"
                  to="/weserve_admin_login/-/reportdashboard/main"
                  class="pa-4"
                >
                  <v-icon color="black">arrow_back</v-icon></v-btn
                ></span
              >
              <span class="main-title">MAIN DASHBOARD | &nbsp;</span>
              <span class="submain-title">Dine in sale store report</span>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <storeReportList />
  </div>
</template>

<script>
import storeReportList from "@/components/back-office/Report/DineInSaleStore";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      
    };
  },
  components: {
    storeReportList,
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
